export default {
  state: {
    selection: [],
    options: [],
  },

  mutations: {
    setSelection(state, selection) {
      state.selection = selection;
    },

    setOptions(state, options) {
      state.options = options;
    },
  },
};
